import React from "react"
import { AuthorizedRoutes } from "./AuthorizedRoutes.router"
import { UnauthorizedRoutes } from "./UnauthorizedRoutes.router"
import { useSession } from "../hooks/auth/useSession.hook"
import { NavigationBlockProvider } from "../contexts/NavigationBlock.context"
import SidebarContext from "../contexts/SidebarContext"

export function MainRouter() {
  const { user } = useSession()
  if (user === undefined) {
    return null
  }
  return (
    <NavigationBlockProvider>
      <SidebarContext>
        {user === null ?
          <UnauthorizedRoutes />
        : <AuthorizedRoutes />}
      </SidebarContext>
    </NavigationBlockProvider>
  )
}
